<template>
    <section>
        <div class=" flex">

            <div>
                <WelcomeBanner/>
            </div>
            <div class="w-4/5 md:w-full md:pr-2">
                <div>
                    <TrackOrderHeader/>
                </div>

                <div class="w-3/5 m-auto mt-52 md:w-full md:ml-2 font-poppins sm:w-full sm:ml-3 md:pr-2">
                    <div>
                        <div v-if="notFound" class=" text-red-500 text-sm mb-4">
                            <p>Tracking Number is incorrect</p>
                        </div>
                        <form @submit.prevent="checkTrackingNumber" >
                            <input v-model="trackingNumber" type="text" name="tracking-number" id="tracking-number" class=" w-full bg-gray-200 p-3 rounded-xl pl-6 outline-none" placeholder="Enter tracking number">
                            <p v-show="numberValidity" class=" text-sm text-red-500">Please enter your tracking number</p>
                            <div class="w-1/2 md:w-1/2 m-auto mt-12">
                                <button  type="submit" class=" bg-blue-700 text-white w-4/5 p-1 rounded-lg" >Track Order 
                                <i v-if="isLoading" class="fa fa-spin fa-spinner border-blue-900 "></i>
                                 </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            

            
        </div>

    </section>
</template>

<script>
import TrackOrderHeader from './TrackOrderHeader.vue';
import WelcomeBanner from './WelcomeBanner.vue';
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        TrackOrderHeader,
        WelcomeBanner
    },

    data() {
        return {
            trackingNumber: '',
            numberValidity: false,
            isLoading: false,
            notFound: false,
        }
    },

    mounted() {
        this.checkTrackingNumber();
    },
    
    methods: {
        checkTrackingNumber() {
            if (!this.trackingNumber) {
                this.numberValidity = true;
                setTimeout(() => {
                    this.numberValidity = false;
                }, 3000);
            } else {
                this.$store.commit("setAuthentication", true)            
                this.isLoading = true
                axios({
                    method: 'GET',
                    url: `${url}/v1/web/orders/${this.trackingNumber}`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                })
                .then((response) => {
                    this.isLoading = false
                    let trackingId = response.data.data.trackingNumber
                    localStorage.setItem('trackingNumber', trackingId);
                    this.$router.push('/trackinginfo')
                })
                .catch((error) => {
                    if(error.response.data.code === 404) {
                        this.notFound = true;
                        setTimeout(() => {
                        this.notFound = false
                    }, 3000);
                    }
                    this.isLoading = false
                })
            }
        }
    }
}
</script>